import { getEnumValues } from '../enums/get-enum-values';
export enum CrudPermission{
	Create = 'create',
	Read = 'read',
	Update='update',
	Delete='delete',

	ListAll='list-all',
}
export const CrudPermissions = getEnumValues<CrudPermission>(CrudPermission);